const DEFAULT_STORY_STICKER_HEIGHT = 0.8;

type StoryFieldSource = {
  storyType?: string | null;
  storyUrl?: string | null;
  storyLabel?: string | null;
  storyStickerHeight?: number | null;
  publishStoryManually?: boolean;
};

type PickedStoryFields<T extends StoryFieldSource> = Pick<
  T,
  "storyType" | "storyUrl" | "publishStoryManually"
>;

/**
 * `forApi` sends null for an empty label, and no sticker height without a
 * story link. Reading a post keeps the label as stored and always defaults
 * the height.
 */
export function pickStoryFields<T extends StoryFieldSource>(
  source: T
): PickedStoryFields<T> &
  Pick<T, "storyLabel"> & { storyStickerHeight: number };
export function pickStoryFields<T extends StoryFieldSource>(
  source: T,
  options: { forApi: true }
): PickedStoryFields<T> & {
  storyLabel: NonNullable<T["storyLabel"]> | null;
  storyStickerHeight: number | null;
};
export function pickStoryFields(
  source: StoryFieldSource,
  { forApi = false }: { forApi?: boolean } = {}
) {
  const storyStickerHeight =
    source.storyStickerHeight || DEFAULT_STORY_STICKER_HEIGHT;

  return {
    storyType: source.storyType,
    storyUrl: source.storyUrl,
    storyLabel: forApi ? source.storyLabel || null : source.storyLabel,
    storyStickerHeight: forApi && !source.storyUrl ? null : storyStickerHeight,
    publishStoryManually: source.publishStoryManually,
  };
}
